import NetworkHandler from 'utils/network';
import config from 'config';

function getRouteById(routeId) {
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}`);
}
function getAllRoute() {
    return NetworkHandler.get(`${config.getUrl('bus_stops')}`);
}

function getRouteTrip({ routeId, tripCode }) {
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/trips/${tripCode}`);
}

function getRouteLineStops({ routeId, lineId }) {
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/lines/${lineId}/stops?size=300`);
}

function getRouteSchedule(routeId, page, size) {
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/schedules`, {
        params: {
            page: page ? page - 1 : null,
            size: size,
        },
    });
}

function deleteAssignTripMultiptle(routeId, params) {
    return NetworkHandler.put(`${config.getUrl('bus_route')}/${routeId}/trips`, params);
}
function confirmTime(params) {
    return NetworkHandler.post(`${config.getUrl('route_trip')}/confirm-time`, params);
}
function confirmNoReturn(params) {
    return NetworkHandler.post(`${config.getUrl('route_trip')}/confirm-no-returned`, params);
}

function exportStops(routeId) {
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/export-stops`);
}

export default {
    getRouteById,
    getRouteTrip,
    getRouteLineStops,
    getRouteSchedule,
    getAllRoute,
    deleteAssignTripMultiptle,
    confirmTime,
    confirmNoReturn,
    exportStops,
};
